import { createSlice } from '@reduxjs/toolkit';

const initialState = { show: false, openPayment: false, clientSecret: null };

const slice = createSlice({
  name: 'subscriptionModal',
  initialState: initialState,
  reducers: {
    openSubscriptionModal: (state, { payload }) => ({
      show: payload?.show != null ? payload?.show : true,
      openPayment: payload?.openPayment ?? false,
      clientSecret: payload?.clientSecret ?? null,
    }),
    closeSubscriptionModal: () => ({ ...initialState }),
  },
});

export const { openSubscriptionModal, closeSubscriptionModal } = slice.actions;

export default slice.reducer;
